
import Vue from 'vue'
import SearchForm from '~/components/ui/search/search-form/index.vue'

export default Vue.extend({
  components: {
    SearchForm
  },
  props: {
    showSearch: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data () {
    return {
      searchString: undefined
    }
  },
  watch: {
    showSearch (newValue) {
      if (!newValue) {
        this.searchResult = []
      }
    }
  },
  methods: {
    handleCloseSearch () {
      this.$emit('close')
    },

    searchFor () {
      this.$router.push('/search' + (this.searchString ? `?for=${this.searchString}` : ''))
    }
  }
})
